import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Mask, Toast, Tab, NavBar, NavBarItem, TabBody, ButtonArea, Button, Grid, ActionSheet, Dialog} from 'react-weui';
import axios from 'axios';
import FileSelector from '../FileSelector';
import { setEvent } from '../../utils';

import '../../styles/classroom/ClassroomPPTMaterialPanel.css';


class ClassroomPPTMaterialPanel extends Component {
    state = {
        showTipDialog: false,
        showLoadingToast: false,
        showMenu: false,
        menus: [
            {label: '选择', onClick: this.onSelectPPT.bind(this)},
            {label: '删除', className: 'danger', onClick: this.onDeletePPT.bind(this)}
        ],
        styles: {
            buttons: [
                {label: '关闭', onClick: this.onHideTipDialog.bind(this)}
            ]
        },
        tipContent: '',
    };

    globalId = 0;
    busy = false;

    getNewId() {
        this.globalId++;
        return this.globalId;
    }

    componentDidMount() {
        this.ticks = setInterval(() => {
            if (this.busy) return null;
            this.checkStatus();
        }, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.ticks);
    }

    checkStatus() {
        let {lecture, ppts} = this.props;
        ppts.map((m) => {
            if (m.status === 'queued' && !this.busy) {
                this.busy = true;
                window.wx.uploadImage({
                    localId: m.small_ppt_url,
                    isShowProgressTips: 1,
                    complete: (res) => {
                        if (res.serverId) {
                            this.props.dispatch({
                                type: 'CLASSROOM_UPDATE_PPT',
                                payload: {
                                    id: m.id,
                                    old_id: m.id,
                                    status: 'upload',
                                    from: 'weixin',
                                    content: res.serverId,
                                },
                            });
                        }

                        this.busy = false;
                    }
                });
            }
            if (m.status === 'upload' ) {
                m.status = 'uploading';

                let form = new FormData();

                form.append('from', m.from)
                form.append('ts', m.ts)
                if (m.from === 'weixin'){
                    form.append('content', m.content)
                } else {
                    form.append('image', m.image)
                }

                console.log(m)

                // 如果有源页面的话，发送事件
                if(sessionStorage.getItem('event_source_page')) {
                    setEvent('cr_sd_msg_evt', { lecture_id: lecture.id })
                    sessionStorage.removeItem('event_source_page');
                }

                axios.post(`/api/classroom/${lecture.id}/ppt/add`, form, {
                    headers: {'content-type': 'multipart/form-data'}
                }).then((response) => {
                    if (response.data.code === 0) {
                        const {ppt} = response.data.data;
//                        m.old_id = m.id;
//                        m.status = null;
//                        m.small_ppt_url = ppt.small_ppt_url;
//                        m.ppt_url = ppt.ppt_url;
//                        m.id = ppt.id;
                        this.props.dispatch({
                            type: 'CLASSROOM_UPDATE_PPT',
                            payload: {
                                old_id: m.id,
                                status: null,
                                medium_ppt_url: ppt.medium_ppt_url,
                                small_ppt_url: ppt.small_ppt_url,
                                ppt_url: ppt.ppt_url,
                                id: ppt.id,
                            },
                        });
                    } else {
                        this.setState({showTipDialog: true, tipContent: response.data.msg});
                    }
                }).catch((error) => {
                    alert(JSON.stringify(error))
                })
            }
            return null
        });
    }

    render() {
        let {showLoadingToast, menus, showMenu, styles, tipContent, showTipDialog} = this.state;
        let {ppts} = this.props;
        if (!this.props.showPPTMaterialPanel) {
            return null;
        }

        return (
            <div>
                <FileSelector multiple={true} ref="file_selector" handleChoose={this.handleChoosePPT.bind(this)}
                              accept="image/*"/>
                <Dialog buttons={styles.buttons} show={showTipDialog}>{tipContent}</Dialog>
                <Mask onClick={this.onRequestClose.bind(this)}/>
                <div className="material-panel">
                    <ActionSheet
                        menus={menus}
                        actions={[{
                            label: '取消',
                            onClick: this.onHideMenu.bind(this)
                        }]}
                        show={showMenu}
                        onRequestClose={this.onHideMenu.bind(this)}
                    />
                    <Toast icon="loading" show={showLoadingToast}>请稍后...</Toast>
                    <Tab>
                        <NavBar>
                            <NavBarItem>PPT</NavBarItem>
                        </NavBar>
                        <TabBody id="material-body">
                            <div className="items">
                                {ppts.map((item, index) => (
                                    <Grid data-id={item.id} style={{backgroundImage: `url(${item.small_ppt_url})`}}
                                          key={item.id}
                                          onClick={e => this.onShowMenu(item)}/>
                                ))}
                            </div>
                        </TabBody>
                        <div className="bottom-bar">
                            <ButtonArea>
                                <Button type="default" onClick={this.onAddPPT.bind(this)}>添加PPT</Button>
                            </ButtonArea>
                        </div>
                    </Tab>
                </div>
            </div>
        )
    }

    onRequestClose() {
        this.props.dispatch({
            type: 'HIDE_PPT_MATERIAL_PANEL'
        })
    }

    onHideMenu() {
        this.setState({showMenu: false})
    }

    onHideTipDialog() {
        this.setState({showTipDialog: false})
    }

    onShowMenu(item) {
        this.setState({showMenu: true});
        this.props.dispatch({
            type: 'CLASSROOM_SET_OPERATE_PPT',
            operatePPT: item
        })
    }

    onSelectPPT() {
        this.setState({showMenu: false});

        let {lecture, operatePPT} = this.props;
        let url = `api/classroom/${lecture.id}/ppt/${operatePPT.id}/select`;
        axios.post(url).then((res) => {
            if (res.data.code !== 0) {
                return this.setState({showTipDialog: true, tipContent: res.data.msg});
            }

            this.onRequestClose();
        });
    }

    onScrollBottom() {
        document.getElementById('material-body').scrollTop = 10000;
    }

    onAddPPT() {
        let {ppts} = this.props;

        if (window.platform !== 'weixin') {
            return this.refs.file_selector.trigger();
        }

        window.wx.chooseImage({
            count: 9, // 默认9
            sizeType: ['origin'], // 可以指定是原图还是压缩图，默认二者都有
            sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
            success: (res) => {
                let newPPTs = [];
                res.localIds.map((localId) => {
                    const item = {
                        type: 'image',
                        small_ppt_url: localId,
                        status: 'queued',
                        id: this.getNewId(),
                        ts: ((new Date().valueOf() * 1000 + this.globalId) * 0.000001).toFixed(6)
                    };
                    newPPTs.push(item);
                    return null
                });
                this.props.dispatch({
                    type: 'CLASSROOM_REFRESH_PPT',
                    ppts: [...ppts, ...newPPTs]
                });
                this.onScrollBottom();
            }
        });
    }

    onDeletePPT() {
        this.setState({showMenu: false});
        let {lecture, ppts, operatePPT} = this.props;
        let url = `api/classroom/${lecture.id}/ppt/${operatePPT.id}/delete`;
        axios.post(url).then((res) => {
            if (res.data.code !== 0) {
                return this.setState({showTipDialog: true, tipContent: res.data.msg});
            }

            if (res.data.code === 0) {
                this.props.dispatch({
                    type: 'CLASSROOM_REFRESH_PPT',
                    ppts: ppts.filter(m => m.id !== operatePPT.id)
                });
            }
        });
    }


    handleChoosePPT(blob, dataUrl) {
        let {ppts} = this.props;
        const item = {
            type: 'image',
            small_ppt_url: dataUrl,
            status: 'upload',
            id: this.getNewId(),
            image: blob,
            from: 'pc',
            ts: ((new Date().valueOf() * 1000 + this.globalId) * 0.000001).toFixed(6)
        };
        this.props.dispatch({
            type: 'CLASSROOM_REFRESH_PPT',
            ppts: [...ppts, item]
        });
        this.onScrollBottom()
    }
}

export default connect((state) => ({
    lecture: state.classroom.lecture,
    showPPTMaterialPanel: state.ppt.showPPTMaterialPanel,
    ppts: state.ppt.ppts,
    operatePPT: state.ppt.operatePPT,
}))(ClassroomPPTMaterialPanel)



// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomPPTMaterialPanel.js